<template>
  <b-form-group
    :label="label"
    :label-size="size"
    :label-class="`font-weight-bold ${
      validate.required === true ||
      (typeof validate === 'string' && validate.search('required') !== -1)
        ? 'is-required'
        : ''
    }`"
  >
    <ValidationProvider
      v-slot="validationContext"
      ref="inputValidation"
      :name="name"
      :rules="validate"
      :mode="validationMode"
    >
      <b-input-group v-if="isFormsearchAutocomplete">
        <b-form-input
          v-model="_value"
          :type="type"
          :name="name"
          :placeholder="placeholder"
          :autocomplete="autocomplete"
          :state="getValidationState(validationContext)"
          :size="size"
          :autofocus="autofocus"
          :step="step"
          :disabled="disabled"
          @change="onchange"
          @focus="removeReadonly"
        >
        </b-form-input>
        <b-input-group-append >
          <b-input-group-text @click="searchbutton" >
            <b-icon icon="search" />
          </b-input-group-text>
        </b-input-group-append>
      </b-input-group>
      
      <b-form-input v-else
        v-model="_value"
        :type="type"
        :name="name"
        :placeholder="placeholder"
        :autocomplete="autocomplete"
        :state="getValidationState(validationContext)"
        :size="size"
        :autofocus="autofocus"
        :step="step"
        :disabled="disabled"
        @change="onchange"
        @focus="removeReadonly"
      >
      </b-form-input>
      <small v-if="helpText" class="text-muted">{{ helpText }}</small>
      <b-form-invalid-feedback
        v-if="showErrorMessage"
        :state="validationContext.errors.length === 0"
      >
        {{ validationContext.errors.join('. ') }}
      </b-form-invalid-feedback>
    </ValidationProvider>
  </b-form-group>
</template>

<script>
export default {
  name: 'InputTextComponent',
  props: {
      idName: {
      type: Number,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    validate: {
      type: [String, Object],
      required: false,
      default: '',
    },
    onchange: {
      type: Function,
      required: false,
      default: () => {},
    },
    searchbutton:{
      type: Function,
      required: false,
      default: () => {},
    },
    familiesData: {
      type: Object,
      required: false,
    },
    showFormsearchFamily: {
      type: Function,
      required: false,
      default: () => {},
    },
    isFormsearchAutocomplete: {
      type: Boolean,
      required: false,
      // eslint-disable-next-line vue/no-boolean-default
      default: false,
    },
    value: {
      type: [String, Number],
      required: false,
      default: null,
    },
    validationMode: {
      type: String,
      required: false,
      default: 'passive',
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    size: {
      type: String,
      required: false,
      default: '',
    },
    step: {
      type: Number,
      required: false,
      default: 1,
    },
    autocomplete: {
      type: String,
      required: false,
      default: '',
    },
    showErrorMessage: {
      type: Boolean,
      required: false,
      // eslint-disable-next-line vue/no-boolean-default
      default: true,
    },
    helpText: {
      type: String,
      default: '',
    },
  },
  computed: {
    _value: {
      get(obj) {
        // setTimeout(() => {
        //   this.$refs['inputValidation'].validate()
        // }, 300)
        return this.value
      },
      set(value) {
        this.value=value.trim()
        this.$emit('update:value', value.trim())
        this.$emit('input', value.trim())
      },
    },
  },
  methods: {
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null
    },
    removeReadonly(event) {
      // fix error readonly on multiple validations?
      if (event.currentTarget.getAttribute('readonly') == 'readonly') {
        event.currentTarget.removeAttribute('readonly')
        event.currentTarget.style.backgroundColor = 'white'
      }
    },
  },
}
</script>
<style lang="scss" >
.modal-body-person {
  position: relative;
  flex: 1 1 auto;
  background: #9b9b9b42;
}
.row-family {
  text-align: start;
  font-size: 12px;
  font-weight: 100;
  width: 100%;
}
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}

.family-tree{
  padding-top: 0.4rem;
  padding-left: 3rem;
}
.radio-family{
  padding-left: 1rem;
  padding-right: 0;
}
</style>